export var WidgetTopic;
(function (WidgetTopic) {
    WidgetTopic["WIDGET_CREATED"] = "widgets/events/created";
    WidgetTopic["WIDGET_REQUEST_CLOSE"] = "widgets/events/request/close";
    WidgetTopic["WIDGET_CLOSE"] = "widgets/events/close";
    WidgetTopic["WIDGET_CLOSED"] = "widgets/events/closed";
})(WidgetTopic || (WidgetTopic = {}));
